<app-header [isScrolled]="true"></app-header>
<ion-content>
  <app-subscribe-banner></app-subscribe-banner>
<!--  <h1>Your Property Guide</h1>-->
  <div class="posts-wrapper">
    @for (post of posts; track post) {
      <app-post-card [post]="post"></app-post-card>
    }
  </div>

  <app-footer></app-footer>
</ion-content>
